<template>
	<v-app class="fill-height background-color">
		<template v-if="isBuying">
			<buy-token />
		</template>
		<template v-if="isLoading">
			<loader />
		</template>
		<v-toolbar 
			app
			dark
			flat
			color="primary"
			class="elevation"
		>
			<v-toolbar-title >
				<span class="font-weight-black">Re121</span>
				<span class="font-weight-thin">Contract Place</span>
			</v-toolbar-title>
			<v-spacer />
			
			<v-toolbar-items>
				<v-btn
					v-if="user"
					flat
					target="_blank"
					@click="logout ()"
				>
					<span class="mr-2">Logout</span>
					<v-icon>fas fa-sign-out-alt</v-icon>
				</v-btn>
			</v-toolbar-items>
		</v-toolbar>

		<v-content>
			<main-view />
			<generic-alert />
		</v-content>

		<v-footer 
			color="primary"
			padless
			app
			absolute
			height="auto"
		>
			<bottom-navigation />
		</v-footer>
	</v-app>
</template>

<script>
import {
	mapGetters,
	mapMutations,
	mapActions,
	mapState
} from 'vuex'

export default {
	computed: {
		...mapGetters ([
			'isBuying',
			'isAuthenticationShown', 
			'user',
			're20IntrinsicValue',
			're721IntrinsicValue',
			'loadingSystemVariables'
		]),
		...mapState ({
			circulatingSupply: state => state.ethereum.circulatingSupply,
			circulatingSupplyNum: state => state.ethereum.circulatingSupplyNum,
			isLoading: state => state.wallet.isLoading
		})
	},
	watch: {
		'user': function (user) {
			// When user becomes null after logout, push to login screen
			if (!user)
				this.$router.push({ path: '/login' })
				return
		}
	},
	methods: {
		...mapMutations (['showAuthentication', 'logout']),
		...mapActions (['updateProfile']),
	}
}
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';

.background-color {
	background-color: $primary;
	overflow-y: hidden;
}

.elevation {
	z-index: 3;
}
</style>
